<template>
	<el-table :data="tableData" border style="width: 100%" @row-click="clickRow">
		<el-table-column prop="qrCode" min-width="30%">
			<template slot-scope="scope">
				<img class="w-100" :src="scope.row.thumbnail" >
					<!-- <img :src="require(`@/assets/images/edge/products/${scope.row.thumbnail}.jpg`)" min-width="70" height="70"/> -->
					<!-- :src="scope.row.thumbnail" -->
			</template>
		</el-table-column>
		<el-table-column prop="PTName" label="型号"  min-width="10%"> </el-table-column>
		<el-table-column label="资源" min-width="30%">
			<template slot-scope="scope">
				<span v-html="scope.row.Resource"></span>
			</template>
		</el-table-column>
		<el-table-column label="简介" min-width="30%">
			<template slot-scope="scope">
				<span v-html="scope.row.Intro"></span>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>	
	export default{
		props: {
			tableDataKey:{
				type: String,
				default:'0'
			},
			tableData: []
		},
		methods:{
			clickRow (row) {
			    this.$router.push("/product-detail/" +row.id);
			},
		}
	}
</script>

<style>
</style>